export default __webpack_public_path__ + "static/media/IMG_20201019_210215 - 5220_ANVIT DUBEY.c11d9bba.jpg";